<div *ngIf="globtroterMenuConfig$ | async as menuConfig" class="flex justify-center bg-globtroterGray pt-[13px] mb-[14px]">
  <nav class="flex justify-between px-4 pt-4 w-full h-36">
    <ng-container [ngSwitch]="globtroterTheme$ | async">
      <img *ngSwitchCase="'polisy'" class="h-24 mb-6" src="assets/mondial-logo.png" />
      <img *ngSwitchCase="'globtroter'" class="h-24 mb-6" src="assets/allianz-logo.svg" />
    </ng-container>

    <div *ngIf="isMobileView$ | async; else desktopView">
      <button nxIconButton="secondary" type="button" (click)="openModal()">
        <nx-icon name="bars" aria-hidden="true"></nx-icon>
      </button>
    </div>
    <ng-template #desktopView>
      <div class="flex flex-col items-end">
        <div class="flex items-baseline gap-6">
          <a [href]="'/' + globtroterApp + staticGlobtroterPaths.news">
            <nx-icon name="bell" size="s" class="text-zinc-500 hover:text-zinc-600 cursor-pointer" />
          </a>
          <div
            *ngIf="globtroterUserName$ | async as userName"
            [nxContextMenuTriggerFor]="userMenu"
            class="flex gap-2 cursor-pointer items-center border border-zinc-500 bg-zinc-100 hover:bg-zinc-200 p-2 px-16"
          >
            <nx-icon name="user" size="s" class="text-zinc-500" />
            <p class="font-semibold text-2xl">{{ userName }}</p>
            <nx-icon name="chevron-down-small" size="s" />
          </div>
          <nx-context-menu #userMenu="nxContextMenu">
            <button nxContextMenuItem type="button">
              <a [href]="'/' + globtroterApp + staticGlobtroterPaths.userProfile">{{ 'globtroter-menu.user-profile' | translate }}</a>
            </button>
            <button nxContextMenuItem type="button">
              <a [href]="'/' + globtroterApp + staticGlobtroterPaths.changePassword">{{ 'globtroter-menu.change-password' | translate }}</a>
            </button>
            <button nxContextMenuItem type="button">
              <a [href]="'/' + globtroterApp + staticGlobtroterPaths.logout">{{ 'globtroter-menu.logout' | translate }}</a>
            </button>
          </nx-context-menu>
        </div>
        <div nx-header class="flex !items-end !border-0 !pr-0 !bg-transparent">
          <nx-header-navigation>
            <nx-header-navigation-item *ngFor="let item of menuConfig">
              <div [ngSwitch]="item.type">
                <a *ngSwitchCase="'menu'" nxHeaderLink class="!mr-6" [nxContextMenuTriggerFor]="menu">
                  <div class="flex items-center cursor-pointer">
                    <p>{{ item.label }}</p>
                    <nx-icon name="chevron-down-small" size="s" />
                  </div>
                </a>
                <a *ngSwitchCase="'link'" nxHeaderLink class="!mr-6" [href]="(item.isSpaLink ? '/' + globtroterApp : '') + item.link">{{
                  item.label
                }}</a>
              </div>

              <nx-context-menu #menu="nxContextMenu">
                <button nxContextMenuItem type="button" *ngFor="let subItem of item.items">
                  <a [href]="(subItem.isSpaLink ? '/' + globtroterApp : '') + subItem.link">{{ subItem.label }}</a>
                </button>
              </nx-context-menu>
            </nx-header-navigation-item>
          </nx-header-navigation>
        </div>
      </div>
    </ng-template>
  </nav>
</div>
